export default class ExerciseAddController {
    constructor($routeParams, $location, exerciseService, notificationsService) {
        this.$location = $location;
        this.exerciseService = exerciseService;
        this.$routeParams = $routeParams;
        this.notificationsService = notificationsService;
        this.documentData = {};

        this.exercise = {
            time: new Date(2018, 1, 1, 9, 0, 0, 0),
            clockBase: new Date(2018, 1, 1, 9, 0, 0, 0),
            exerciseMessageCharacters: 1024
        };
    }

    onSave(file) {
        var that = this; 
            var exercise = {
                id: that.exercise.id,
                name: that.exercise.name,
                time: that.exercise.time,
                clockBase: that.exercise.clockBase,
                eventId: that.$routeParams.eventId,
                description: that.exercise.description,
                postcode: that.exercise.postcode,
                exerciseMessageCharacters: that.exercise.exerciseMessageCharacters,
                themeId: that.exercise.themeId,
                themeAccentColour: that.exercise.themeAccentColour,
                themeCustomName: that.exercise.themeCustomName,
            };

            if(that.documentData.doc && 
                that.documentData.mimetype && 
                that.documentData.fileextension)
            {
                exercise.plan = that.documentData.doc;
                exercise.doctype = that.documentData.mimetype;
                exercise.planFileExtension = that.documentData.fileextension;
            }
                        
            that.exerciseService.insertExercise(exercise).then(resp => {
                that.$location.path("/manage/clients/" + that.$routeParams.clientId + "/events/view/" + that.$routeParams.eventId);
                that.notificationsService.show("Exercise added", "success");
            }, 
            resp => { 
                that.notificationsService.show("Form fields not complete", "error");
            });
    }

    goBack() {
        this.$location.path("/manage/clients/" + this.$routeParams.clientId + "/events/view/" + this.$routeParams.eventId);
    }

    readFile() {
        return new Promise(function (resolve, reject) {
            var f = document.getElementById('file').files[0],
                r = new FileReader(),
                data = [];

                if(!f){
                    resolve(data);
                }

            var mimetype = f.type;

            r.onloadend = function (e) {
                var doc = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));
                data.doc = doc;
                data.mimetype = mimetype;
                data.fileextension = f.name.split('.').pop();
                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
    };
}

function paddingFront(value, length, paddingValue) {
    while (value.length < length) {
        value = paddingValue + value;
    }
    return value;
}


// WEBPACK FOOTER //
// ./src/js/components/exercise/exercise.add.controller.js